import type { ReactNode } from "react";
import { useI18n } from "../i18n";

export function Field({
  label,
  optional,
  hint,
  htmlFor,
  children,
}: {
  label: string;
  optional?: boolean;
  hint?: ReactNode;
  htmlFor?: string;
  children: ReactNode;
}) {
  const { m } = useI18n();
  return (
    <div className="field">
      <div className="field-label-row">
        <label className="field-label" htmlFor={htmlFor}>
          {label}
        </label>
        {optional && <span className="field-optional">{m.common.optional}</span>}
      </div>
      {children}
      {hint && <p className="field-hint">{hint}</p>}
    </div>
  );
}
